import React, { Suspense, lazy } from 'react';
import PagePreloader from '~components/page-preloader';

const CovidPage = lazy(() => import('./index'))

function CovidPageTokenLazy(props) {
    return (
        <Suspense fallback={<PagePreloader />}>
            <CovidPage {...props} />
        </Suspense>
    );
}

export default CovidPageTokenLazy;
export { CovidPageTokenLazy };



// WEBPACK FOOTER //
// ./src/routes/covid-page-token/lazy.js